import { render, staticRenderFns } from "./PedidoPrioridade.vue?vue&type=template&id=736f38a2"
import script from "./PedidoPrioridade.vue?vue&type=script&lang=js"
export * from "./PedidoPrioridade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports